export const SET_LOADING = 'src/store/global/SET_LOADING'
export const SET_STADIUM_DD = 'src/store/global/SET_STADIUM_DD'
export const SET_PROFILE_DD = 'src/store/global/SET_PROFILE_DD'
